module.exports = __webpack_public_path__ + "static/media/coinranking.b69bf1c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Exchange/scenes/Success/img/coinranking.svg
// module id = 136
// module chunks = 0